export const readFileAsText = async (file: File): Promise<string> =>
  new Promise(resolve => {
    const reader = new FileReader();
    reader.addEventListener(
      'load',
      () => resolve(reader.result as string),
      false
    );
    if (file) {
      reader.readAsText(file);
    }
  });
